import { Component } from '@angular/core';

@Component({
    selector: '[s2-svg-history]'
    , templateUrl: './svg-history.component.html'
    , styleUrls: ['./svg-history.component.scss']
    , standalone: false
})
export class SvgHistoryComponent {}
